export const LAYOUT = {
  APPBAR_HEIGHT: 64,
};
